
import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import { Popconfirm, message } from 'antd';
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { Image, Layout, Menu, Breadcrumb, Col, Row ,Divider} from 'antd';
import { Button, Spin, Progress, Table, Tag, Space } from 'antd';
import { Typography, PageHeader } from 'antd';
import axios from 'axios'
import { resolveFileUrl } from './utils/resolveFileUrl';

const { Title } = Typography;
const { Header, Content, Footer } = Layout;
const { Column, ColumnGroup } = Table;

export default class DetailPage extends Component{
  state = {
    data: {
      record_image_urls:[],
      record_report_urls:[]
    },
    username: '',
  }
  curriculum_step_dict={
    'prevet':'예과과정',
    'preclinical': '본과 비임상과정',
    'clinical':'본과 임상과정',
  }
  componentDidMount() {
    let record_id = this.props.match.params.record_id
    let req_data = {
      record_id: record_id
    }
    axios('/record/detail', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
      data: req_data
    }).then( res => {
      let record = res.data.record
      let data = {
        ...record,
        record_image_urls: res.data.record_image_urls,
        record_report_urls: res.data.record_report_urls,
        key: 0,
        etc: record.etc ? record.etc.replace(' ', ', ') : '',
      }
      this.setState({
        ...this.state,
        username: res.data.name,
        data: data,
      })
    });
  }

  deleteRecord(record_id) {
    let req_data = {
      record_id: record_id
    }
    axios('/record/delete', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
      data: req_data
    }).then( res => {
      message.info('성공적으로 삭제되었습니다');
      window.location.href='/'
    });
  }
  render () {
    if (!this.state.data.primary_class) {
      return <div style={{textAlign:'center', marginTop:'100px'}}><Spin size="large" /></div>;
    }
    let data
    if (this.state.data.primary_class == '실습') {
      data= [
        { key: '1', title: '실습 분류1', content: this.state.data.primary_class },
        { key: '2', title: '실습 분류2', content: this.state.data.secondary_class },
        { key: '3', title: '학년 구분', content: this.curriculum_step_dict[this.state.data.curriculum_step] },
        { key: '4', title: '실습 날짜', content: `${new Date(this.state.data.start_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})} - ${new Date(this.state.data.end_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})}` },
        { key: '5', title: '실습 기관', content: this.state.data.institute },
        { key: '6', title: '실습 개요', content: this.state.data.practice },
        { key: '7', title: '졸업 역량', content: (this.state.data.competency? this.state.data.competency.split(' ').map((x) => {return <Tag>{x}</Tag>}) : '') },
        { key: '8', title: '비고', content: this.state.data.etc },
        { key: '9', title: '실습 담당자', content: this.state.data.professor },
        { key: '10', title: '실습 담당자 연락처', content: this.state.data.professor_phone },
        { key: '11', title: '실습 성과', content: <pre style={{whiteSpace:'pre-line'}}>{this.state.data.report}</pre> },
        ...(this.state.data.record_report_urls.length > 0 ? [{ key: '13', title: '실습 보고서', content: (
            <Image.PreviewGroup>
              { this.state.data.record_report_urls.map((url) => {
                  return (<Link onClick={() => {window.open(resolveFileUrl(url)) }}> <Image width={100} src={'/file_png.png'} disabled/></Link>)
                })
              }
            </Image.PreviewGroup>
          )
        }] : []),
        { key: '14', title: '실습 사진', content: (
            this.state.data.record_image_urls.length > 0
              ? <Image.PreviewGroup>
                  { this.state.data.record_image_urls.map((url) => {
                      return (<Image width={200} src={resolveFileUrl(url)} />)
                    })
                  }
                </Image.PreviewGroup>
              : <span style={{color: '#999'}}>등록된 사진이 없습니다</span>
          )
        },
        { key: '15', title: '승인 상태', content: <Tag>{this.state.data.state}</Tag> },
        ...(this.state.data.deny_comment ? [{ key: '16', title: '반려 사유', content: <span style={{color:'#f5222d'}}>{this.state.data.deny_comment}</span> }] : []),
      ];
    } else if (this.state.data.primary_class == '활동') {
      data= [
        { key: '1', title: '실습 분류1', content: this.state.data.primary_class },
        { key: '2', title: '실습 분류2', content: this.state.data.secondary_class },
        { key: '3', title: '학년 구분', content: this.curriculum_step_dict[this.state.data.curriculum_step] },
        { key: '4', title: '활동 기간', content: `${new Date(this.state.data.start_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})} - ${new Date(this.state.data.end_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})}` },
        { key: '5', title: '활동 제목', content: this.state.data.institute },
        { key: '6', title: '활동 개요', content: this.state.data.practice },
        { key: '7', title: '졸업 역량', content: (this.state.data.competency? this.state.data.competency.split(' ').map((x) => {return <Tag>{x}</Tag>}) : '') },
        { key: '8', title: '비고', content: this.state.data.etc },
        { key: '9', title: '활동 지도 전문가', content: this.state.data.professor },
        { key: '10', title: '전문가 연락처', content: this.state.data.professor_phone },
        { key: '11', title: '활동 성과', content: <pre style={{whiteSpace:'pre-line'}}>{this.state.data.report}</pre> },
        ...(this.state.data.record_report_urls.length > 0 ? [{ key: '13', title: '활동 보고서', content: (
            <Image.PreviewGroup>
              { this.state.data.record_report_urls.map((url) => {
                  return (<Link onClick={() => {window.open(resolveFileUrl(url)) }}> <Image width={100} src={'/file_png.png'} disabled/></Link>)
                })
              }
            </Image.PreviewGroup>
          )
        }] : []),
        { key: '14', title: '관련 이미지', content: (
            this.state.data.record_image_urls.length > 0
              ? <Image.PreviewGroup>
                  { this.state.data.record_image_urls.map((url) => {
                      return (<Image width={200} src={resolveFileUrl(url)} />)
                    })
                  }
                </Image.PreviewGroup>
              : <span style={{color: '#999'}}>등록된 사진이 없습니다</span>
          )
        },
        { key: '15', title: '승인 상태', content: <Tag>{this.state.data.state}</Tag> },
        ...(this.state.data.deny_comment ? [{ key: '16', title: '반려 사유', content: <span style={{color:'#f5222d'}}>{this.state.data.deny_comment}</span> }] : []),
      ];
    } else if (this.state.data.primary_class == '자기학습') {
      data= [
        { key: '1', title: '실습 분류1', content: this.state.data.primary_class },
        { key: '2', title: '실습 분류2', content: this.state.data.secondary_class },
        { key: '3', title: '학년 구분', content: this.curriculum_step_dict[this.state.data.curriculum_step] },
        { key: '4', title: '자기학습 기간', content: `${new Date(this.state.data.start_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})} - ${new Date(this.state.data.end_at).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})}` },
        { key: '6', title: '자기학습 개요', content: this.state.data.practice },
        { key: '7', title: '졸업 역량', content: (this.state.data.competency? this.state.data.competency.split(' ').map((x) => {return <Tag>{x}</Tag>}) : '') },
        { key: '8', title: '비고', content: this.state.data.etc },
        { key: '11', title: '자기학습 성과', content: <pre style={{whiteSpace:'pre-line'}}>{this.state.data.report}</pre> },
        ...(this.state.data.record_report_urls.length > 0 ? [{ key: '13', title: '자기학습 성과 보고서', content: (
            <Image.PreviewGroup>
              { this.state.data.record_report_urls.map((url) => {
                  return (<Link onClick={() => {window.open(resolveFileUrl(url)) }}> <Image width={100} src={'/file_png.png'} disabled/></Link>)
                })
              }
            </Image.PreviewGroup>
          )
        }] : []),
        { key: '14', title: '관련 이미지', content: (
            this.state.data.record_image_urls.length > 0
              ? <Image.PreviewGroup>
                  { this.state.data.record_image_urls.map((url) => {
                      return (<Image width={200} src={resolveFileUrl(url)} />)
                    })
                  }
                </Image.PreviewGroup>
              : <span style={{color: '#999'}}>등록된 사진이 없습니다</span>
          )
        },
        { key: '15', title: '승인 상태', content: <Tag>{this.state.data.state}</Tag> },
        ...(this.state.data.deny_comment ? [{ key: '16', title: '반려 사유', content: <span style={{color:'#f5222d'}}>{this.state.data.deny_comment}</span> }] : []),
      ];
    }

      return (
      <>
      <PageHeader
        className="site-page-header"
        onBack={() => window.history.back() }
        title={this.state.data.institute}
        subTitle="상세 실습 내역"
      />
      <Table dataSource={data} style={{margin:'0 50px' ,marginLeft:'150px', marginRight:'150px'}}
      pagination={false}
      >
        <Column columnWidth='80px' title="" dataIndex="title" key="title" />
        <Column title="" dataIndex="content"
        style={{ whiteSpace: 'pre-line' }}
        key="content" />
      </Table>
      <Divider orientation='right'>
        <Space>
        <Button disabled={this.state.data.state == '승인완료'}
        type='primary'
        onClick={() => { window.location.href='/modify/' + this.props.match.params.record_id }}
        >
          수정
        </Button>
        <Popconfirm
          placement="bottomRight"
          title='해당 실습 기록을 삭제하시겠습니까?'
          onConfirm={() => this.deleteRecord(this.props.match.params.record_id)}
          okText="Yes"
          cancelText="No"
        >
          <Button danger >
            삭제
          </Button>
        </Popconfirm>
        </Space>
      </Divider>
      </>
      )
  };
};
